var BufferListChildView = require('bufferlistchildview');


var BufferListChannelView = BufferListChildView.extend({
    className: BufferListChildView.prototype.className + ' channel',
    getTemplate: function () {
        if (!BufferListChannelView._structure) {
            var structure = BufferListChildView.prototype.getTemplate.call(this);
            structure.append('<i class="fa fa-lock">');
            BufferListChannelView._structure = structure;
        }
        return BufferListChannelView._structure.clone();
    },
    render: function () {
        BufferListChildView.prototype.render.call(this);
        
        this.renderMode();
        this.renderTwitch();
        this.model.bind('modeChange', this.renderMode, this);
        this.model.bind('twitchChannelChange', this.renderTwitch, this);
        return this;
    },
    renderMode: function () {
        $(this.el).toggleClass('secret', this.model.hasMode('s'));
        $(this.el).toggleClass('private', this.model.hasMode('p'));
        $(this.el).toggleClass('moderated', this.model.hasMode('m'));
        $(this.el).toggleClass('inviteOnly', this.model.hasMode('i'));
        $(this.el).toggleClass('password', this.model.isPassworded());
        $(this.el).toggleClass('topicControl', this.model.hasMode('t'));
        $(this.el).toggleClass('noExternal', this.model.hasMode('n'));
        $(this.el).toggleClass('limited', this.model.hasMode('l'));
        return this;
    },
    renderTwitch: function () {
        if (this.model.connection.isTwitch()) {
            this.renderLinkText();
            $(this.el).toggleClass(
                'twitch_restricted_room',
                this.model.isTwitchRestrictedRoom()
            );
        }
    },
    renderLinkText: function () {
        var displayName = this.model.getDisplayName();
        var tooltip = this.model.getDisplayNameWithConnection();
        var twitchInfo = this.model.getTwitchInfo();
        var twitchDisplayName = this.model.getTwitchDisplayName(twitchInfo);
        if (twitchDisplayName) {
            if (twitchInfo.game) {
                tooltip = 'Playing ' + twitchInfo.game;
                if (twitchInfo.viewers) {
                    tooltip += ' (' + twitchInfo.viewers.toLocaleString() + ' viewers)';
                }
            } else if (twitchInfo.viewers) {
                tooltip = twitchInfo.viewers.toLocaleString() + ' viewers';
            } else {
                tooltip = 'Offline';
            }
            var tooltipPrefix = twitchDisplayName;
            if (twitchInfo.channel.name.toLowerCase() != twitchDisplayName.toLowerCase()) {
                tooltipPrefix += ' (' + twitchInfo.channel.name + ')';
            }
            tooltip = tooltipPrefix + ' — ' + tooltip;
            displayName = twitchDisplayName;
        }
        if (this.model.isTwitchRoom()) {
            var roomParts = this.model.getTwitchRoomNameParts();
            if (roomParts) {
                tooltip = roomParts.join(' : ');
            }
        }
        this.link.attr('title', tooltip);
        this.setLinkLabelHtml(this.formatter.render(this.model.disambiguateListName(displayName, this.model.getName())));

        if (twitchDisplayName) {
            if (twitchInfo.viewers) {
                var twitchStatus = $('<span class="twitchStatus">');
                twitchStatus.append('<i class="fa fa-play-circle">');
                this.linkLabel.prepend(twitchStatus);
            }
        }
        var safeChanSuffix = this.model.safeChanSuffix();
        if (safeChanSuffix) {
            this.linkLabel.append(' ').append($('<small>').text(safeChanSuffix));
        }
        return this;
    }
});


module.exports = BufferListChannelView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistchannelview.js
// module id = /ybZ
// module chunks = 1